import Gift from 'common/components/Gift/Index'
import withInjection from '@piconetworks/with-injection'

import WizardRedux from 'common/pkgs/WizardRedux'
import Router from 'common/modules/router'
import Wizard from 'common/modules/wizard'
import Loader from 'common/modules/loader'

const mapStateToProps = (state, props) => {
    const defaultPopup = Loader.selectors.getDefaultPopup(state)

    const wizardName = props?.router?.query?.id
    const popupId = props?.router?.query?.popupId || defaultPopup?.id

    return {
        ...props,
        WizardRedux,
        wizard: state.wizard,
        wizards: state.wizard.wizards,
        wizardsRemoved: () => Object.keys(state.wizard.wizards).length === 0,
        submitActionType: Router.types.PUSH,
        submitPayload: {
            url: {
                pathname: '/thank-you',
                query: wizardName && { id: wizardName },
                completedWizard: 'GiftWizard',
            },
            as: {
                pathname: '/thank-you',
                query: wizardName && { id: wizardName },
                completedWizard: 'GiftWizard',
            },
            popupId,
        },
    }
}

const mapDispatchToProps = (dispatch) => ({
    onComponentDidMount: (wizardStore) => {
        Object.keys(wizardStore.wizards).forEach((wizardName) => {
            dispatch(
                Wizard.creators.deleteWizard({
                    payload: {
                        id: wizardName,
                    },
                }),
            )
        })
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onComponentDidMount: () => {
        const { wizard: wizardStore } = stateProps
        dispatchProps.onComponentDidMount(wizardStore)
    },
})

const InjectedGift = withInjection(Gift, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedGift
